﻿class LetterIndexScroller {
    constructor(_elm) {
        this.elm = _elm;

        this.destroyTimeout = null;
        this.isDestroying = false;

        this.init();
    }

    init() {
        this.$elm = $(this.elm);
        this.$content = this.$elm;

        this.contentBoundingBox = null;
        this.scrollerBoundingBox = null;

        this.scrollPos = 0;
        this.scrollPosInterval = 2;
        this.scrollIntervalTimeout = 10;

        this.scrollInterval = null;

        this.contentWidth = null;
        this.contentOffset = 2;

        this.setStyles();

        this.$content.wrap('<div class="letterIndex-wrapper" />');
        this.$content.wrap('<div class="letterIndex-scroller" />');

        this.contentWidth = this.calculateContentWidth();
        this.$content.width(this.contentWidth);
        
        //recache this.$content obj.
        this.$content = $(this.elm);

        this.$wrapper = this.$elm.closest('.letterIndex-wrapper');
        this.$scroller = this.$elm.closest('.letterIndex-scroller');

        this.addNavigation();

        this.contentBoundingBox = $.rectangle(this.$content[0]);
        this.scrollerBoundingBox = $.rectangle(this.$scroller[0]);

        this.setEventListeners();
    }

    destroy(_this) {
        _this.removeEventListeners(_this);
        _this.removeStyles();
        _this.$content.css({ width: 'auto', transform: 'translateX(0)'});
        _this.removeNavigation();
    }

    setEventListeners() {
        this.$wrapper.find('.letterIndex-nav--prev').on('mouseover', this.onPreviousMouseEnter.bind(this));
        this.$wrapper.find('.letterIndex-nav--prev').on('mouseleave', this.onPreviousMouseLeave.bind(this));
        this.$wrapper.find('.letterIndex-nav--next').on('mouseover', this.onNextHoverMouseEnter.bind(this));
        this.$wrapper.find('.letterIndex-nav--next').on('mouseleave', this.onNextHoverMouseLeave.bind(this));

        this.$content.find('li a').on('click', this.onItemClick.bind(this));

        $(window).on('resize', this.onResize.bind(this));
    }

    removeEventListeners() {
        this.$wrapper.find('.letterIndex-nav--prev').off('mouseover');
        this.$wrapper.find('.letterIndex-nav--prev').off('mouseleave');
        this.$wrapper.find('.letterIndex-nav--next').off('mouseover');
        this.$wrapper.find('.letterIndex-nav--next').off('mouseleave');

        this.$content.find('li a').off('click');
    }

    setStyles() {
        this.$content.addClass('letterIndex--isScroller');
    }

    removeStyles() {
        this.$content.removeClass('letterIndex--isScroller');
    }

    calculateContentWidth() {
        var $items = this.$content.find('li');
        var itemWidth = $.rectangle($items[0]).width;
        if (!itemWidth) itemWidth = 42; // fallback for timing issues in JS
        var itemMargin = 10; //token?
        return (($items.length * (itemWidth + itemMargin)) - itemMargin) + this.contentOffset;
    }

    addNavigation() {
        this.$scroller.before('<div class="letterIndex-nav letterIndex-nav--prev">');
        this.$scroller.after('<div class="letterIndex-nav letterIndex-nav--next">');
    }

    removeNavigation() {
        this.$wrapper.find('.letterIndex-nav').remove();
    }

    scroll(directionIsRight = false) {
        this.scrollInterval = setInterval(() => {
            let intervalValue = directionIsRight
                ? Math.abs(this.scrollPosInterval)
                : -Math.abs(this.scrollPosInterval);

            var newScrollPos = this.scrollPos + intervalValue;
            var negativeOffset = -Math.abs(this.contentWidth - this.scrollerBoundingBox.width);

            var execute = directionIsRight
                ? (newScrollPos < 0)
                : (newScrollPos > negativeOffset);

            if (execute) {
                let offset = directionIsRight
                    ? Math.abs(this.contentOffset)
                    : -Math.abs(this.contentOffset);

                this.$content.css({
                    transform: `translateX(${newScrollPos + offset}px)`
                });

                this.scrollPos = newScrollPos;
            }

        }, this.scrollIntervalTimeout);
    }

    onPreviousMouseEnter(event) {
        this.scroll(true);
    }

    onPreviousMouseLeave(event) {
        clearInterval(this.scrollInterval);
    }

    onNextHoverMouseEnter(event) {
        this.scroll();
    }

    onNextHoverMouseLeave(event) {
        clearInterval(this.scrollInterval);
    }

    onItemClick(event) {
        event.preventDefault();
        var $target = $(event.target).closest('a');
        var href = $target.attr('href');

        var headerBoundingBox = $.rectangle($("header"));
        var offset = headerBoundingBox.height + 20; //token?

        $(window).scrollTo($(href), 200, {
            offset: offset - (offset * 2)
        });
    }

    onResize(event) {
        clearTimeout(this.destroyTimeout);

        if (!this.isDestroying) {
            this.isDestroying = true;
            this.destroy(this);
        }
        
        this.destroyTimeout = setTimeout(() => {
            this.isDestroying = false;
            this.init(this);
        }, 200);
    }
}

export default LetterIndexScroller;